export const Alpha = (color = "#000000", alphaNumber = 0) => {
  if (
    typeof color === "string" &&
    color.length === 7 &&
    typeof alphaNumber === "number" &&
    (alphaNumber >= 0 || alphaNumber <= 1)
  ) {
    const hexArr = [color.substr(1, 2), color.substr(3, 2), color.substr(5, 2)];
    const alphaArr = [
      parseInt(hexArr[0], 16),
      parseInt(hexArr[1], 16),
      parseInt(hexArr[2], 16),
    ];

    return `rgba(${alphaArr.join(",")}, ${alphaNumber})`;
  }

  return "transparent";
};

const DANGER = "#F44336";
const ERROR = "#E31B0C";
const WARNING_SHADES_MAIN = "#ED6C02";

export const Colors = {
  PRIMARY_BLUE: "#1077B9",
  PRIMARY_BLUE_SHADE: "#1077B914",
  PRIMARY_BLUE_SHADE_LIGHT: "#1077B90A",
  PRIMARY_DARK: "#161F3B",
  SECONDARY_MEDIUM: "#263465",
  SECONDARY_DARK: "#0B5583",
  SECONDARY_SHADE: "#1077B91F",
  SECONDARY_MEDIUM_SHADE: "#1077B980",
  SUCCESS: "#1EB44B",
  SUCCESS_DARK: "#3B873E",
  SUCCESS_LIGHT: "#4CAF50",
  SUCCESS_LIGHT_SHADE: "#2E7D321F",
  SUCCESS_LIGHTER: "#B1C750",
  DANGER,
  DANGER_LOW_OPACITY: Alpha(DANGER, 0.1),
  DANGER_SHADES: "#D32F2F0A",
  ERROR,
  WARNING: "#FF9800",
  WARNING_DARK: "#ED6C02",
  WARNING_SHADES: "#ED6C020A",
  WARNING_LIGHT: Alpha(WARNING_SHADES_MAIN, 0.08),
  WARNING_SHADES_MAIN,
  ERROR_DARK: "#E31B0C",
  INFO_DARK: "#2196F3",
  INFO_SHADES: "#1077B90A",
  GRAY_DARKEST: "#606060",
  GRAY_DARKER: "#909090",
  GRAY_DARK_LIGHT: "#C4C4C4",
  GRAY: "#C0C0C0",
  GRAY_LIGHEST_LIGHT: "#FAFAFA",
  GRAY_LIGHT: "#E0E0E0",
  GRAY_LIGHTER: "#F0F0F0",
  GRAY_LIGHTEST: "#FBFBFB",
  GRAY_CHART_LABEL: "#C0C7CE",
  GRAY_MEDIUM: "#9E9E9E",
  BLUE_LIGTHER: "#FAFAFF",
  BLUE_LIGHT: "#E7F0F5",
  BLUE_DARKER: "#C6DEEE",
  BLUE_DARKEST: "#01518A",
  BLUE_TURNKEY: "#4DB7E9",
  BLUE_VIVID: "#229DEC",
  BLUE_VIVID_LIGHT: "#E3F2FD",
  GREEN_DARKER: "#B1C750",
  GREEN_LIGHT: "#006064",
  GREEN_LIGHT_SHADE: "#E0F2F1",
  GREEN_LIGHT_OPACITY: "#E8F5E9",
  GREEN_DARK_SHADE: "#006064",
  GREEN_DARKER_SHADE: "#388E3C",
  ORANGE: "#F9A61E",
  ORANGE_DARKER: "#D88000",
  YELLOW_LIGHT: "#FFF6E5",
  LAVANDER_LIGHT: "#EDE7F6",
  LAVANDER_DARK: "#311B92",
  WHITE: "#FFF",
  TEXT_SECONDARY_BLACK: "#00000099",
  BACKGROUND_DISABLE: "#A4A4A4",
  TEXT_PRIMARY: "#000000DE",
  BLUE_GRAY_LIGHT: "#ECEFF1",
  BLUE_GRAY_DARK: "#263238",
  RED_LIGHT: "#FFEBEB",
  INDIGO_LIGHT: '#5C6BC0',
  INDIGO_LIGHT_SHADE: '#E8EAF6',
  INDIGO_DARKER: '#1A237E',
  AMBER_LIGHT: '#FF6F00',
  AMBER_LIGHT_SHADE: '#FFF8E1',
  PINK_MEDIUM: '#E91E63',
  PINK_LIGHT_SHADE: '#FCE4EC',
  TEAL_DARK: '#009688',
  TEAL_LIGHT_SHADE: '#E0F2F1',
  BLUE_LIGHT_SHADE: '#E1F5FE',
  BLUE_DARK: '#039BE5',
  YELLOW_DARKER: '#F57F17',
  YELLOW_LIGHT_SHADE: '#FFFDE7',
  Alpha,
};
